import React, { Component } from "react";
import { NavLink as Link } from "react-router-dom";
import { DATERANGE_DATE_TIME_FORMAT, STATUS_SUCCESS } from './../../config/global_constants';
import { translate, formatDate } from './../../helpers/intl_helpers';
import { callBackendAPI, generateSource, customConfirmBox, reFormatSuccess, formatPhoneNumber} from './../../helpers/common';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip'

import ReplaceEmployee from "./ReplaceEmployee";

import warningIcon from './../../assets/images/warning_outline_icon.svg';
import userProfileIcon from './../../assets/images/user_profile_icon.svg';
import infoIcon from './../../assets/images/info-icon-yellow.svg';
import addIcon from './../../assets/images/add_blue_icon.svg';
import threeDotsIcon from './../../assets/images/three_dot_icon.svg';

export default class EmpList extends Component {
	constructor(props) {
		super(props)

		this.state = {
			showReplaceEmp: false,
			empDetails: {}
		};
	}

	/**Handle onclick function for remove employee from oncall schedule */
	handleRemove = (e, empId, scheduleId) => {
		e.stopPropagation();

		let confirmation = customConfirmBox(translate("on_call.you_want_to_remove"));
		confirmation.then((confirmed) => {
			if (confirmed) {
				/** Generate source for cancel token */
				this.source = generateSource();
				/** Set API request params */
				let apiReq = [{ model: 'on_call', method: 'remove-employee', schedule_id: scheduleId, employee_id: empId }];

				callBackendAPI(apiReq, this.source).then(response => {
					if (response.success && response.data[0].status === STATUS_SUCCESS) {
						// this.props.getOnCallList();
						this.props.requestOncallModal(false)
						reFormatSuccess(response.data[0].message)
					}
				}).catch(err => console.log(err));
			}
		});
	}

	handleReplaceModal = (e, val, empData) => {
		this.setState({
			showReplaceEmp: val,
			empDetails: empData
		}, () => {
			if (!val) {
				this.props.requestOncallModal(false)
			}
		});
	};

	render() {
		const { showReplaceEmp, empDetails } = this.state;
		const { skillList, skillsObj } = this.props;

		return <>
			<div className='roster-section'>
				{skillList?.length > 0 && skillList?.map((skill, index) => (
					<div className='department-group' key={index}>
						<div className='department-head'>
							<h3>{skill?.label || "N/A"}</h3>
							{(skillsObj[skill?.value] && skillsObj[skill?.value]?.employee_list?.length >= 2) ?
								<span className="requirement-text ms-0 ms-md-auto">{(skillsObj[skill?.value] && skillsObj[skill?.value]?.employee_list?.length) || 0} {translate('on_call.employees')}</span>
								: <span className='warning-badge ms-auto'>
									<img className="me-2" src={warningIcon} alt="img" />
									{translate('on_call.minimum_2_employees_required')}
								</span>}
							<div className='add-person text-center'>
								<Link to="#" className="btn" onClick={() => this.props.requestOncallModal(true, skill?.value)}><img src={addIcon} alt="img" />{translate('on_call.add')}</Link>
							</div>
						</div>
						{skillsObj[skill?.value]?.employee_list?.length ? (
							<div className="department-body">
								<div className="employee-card">
									{skillsObj[skill?.value] && skillsObj[skill?.value]?.employee_list?.map((emp, index) => (
										<div className={"card-summary " + (emp?.skill_set?.length ? "" : "skill-required")} key={emp._id || index}>
											<div className="employee-info align-items-start align-items-lg-center">
												<img src={userProfileIcon} alt="img" />

												<div>
													<div className="d-flex align-items-center flex-wrap gap-1">
														<h3>{emp?.name || "N/A"}</h3>
														{emp?.skill_set?.length ? "" 
														:
															<span className="skill-signed">{translate('on_call.skill_not_assigned')}</span>
														}
														<span className="skill-badge">{emp?.department?.join(' , ')}</span>
														<span className="customer-badge">
															{emp?.customer_title || "N/A"}
														</span>
													</div>
												</div>

												<div className="ms-auto dropdown cstm-dropdown">
													<button
														className="dropdown-toggle"
														type="button"
														data-bs-toggle="dropdown"
													>
														<img src={threeDotsIcon} alt="img" />
													</button>

													<ul className="dropdown-menu">
														<li>
															<button
																className="dropdown-item"
																onClick={(e) => {
																	this.handleReplaceModal(e, true, emp)
																}}
															>
																{translate('on_call.replace')}
															</button>
														</li>
														<li>
															<button
																type="button"
																className="dropdown-item"
																onClick={(e) => this.handleRemove(e, emp?.employee_id, emp?._id)}
															>
																{translate('on_call.remove')}
															</button>
														</li>
													</ul>
												</div>
											</div>

											<ul className="card-details">
												<li>
													<p>{translate('on_call.title')}</p>
													<span>{emp?.job_title || "N/A"}</span>
												</li>

												<li>
													<p>{translate('on_call.phone')}</p>
													<a href={`tel:${emp?.mobile}`}>
														{formatPhoneNumber(emp?.mobile) || "N/A"}
													</a>
												</li>

												<li>
													<p>{translate('on_call.period')}</p>
													<span>
														{formatDate(emp?.min_date, DATERANGE_DATE_TIME_FORMAT)}-{" "}
														{formatDate(emp?.max_date, DATERANGE_DATE_TIME_FORMAT)}
													</span>
												</li>

												{emp?.replace_emp_name && (
													<li>
														<div className="replace-info d-flex align-items-center">
															<p><strong>{translate('on_call.replaced')}</strong></p>
															<span>
																{emp?.replace_emp_name || "N/A"}

																<OverlayTrigger
																	placement="top"
																	delay={{ show: 250, hide: 400 }}
																	overlay={
																		<Tooltip id={`tooltip-${emp?._id || index}`}>
																			{emp?.replace_reason || "N/A"}
																		</Tooltip>
																	}
																>
																	<img
																		src={infoIcon}
																		className="ms-1"
																		alt="info-icon"
																		style={{ cursor: 'pointer' }}
																	/>
																</OverlayTrigger>
															</span>
														</div>
													</li>
												)}
											</ul>
										</div>
									))}
								</div>
							</div>
						) : null}
					</div>
				))}
				{showReplaceEmp ?
					<ReplaceEmployee empDetails={empDetails} handleReplaceModal={this.handleReplaceModal} />
					: null}
			</div>
		</>
	}
}